export var NAVIGATION_CHANNEL = 'navigation';
export var ANALYTICS_CONTEXT = {
  source: 'atlassianAccountMenu',
  componentName: 'atlassianAccountMenu',
  packageName: "@atlassian/account-menu",
  packageVersion: "0.3.7"
};